import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"hide-details":"auto","items":_vm.items,"outlined":"","label":_vm.$t('Position')},model:{value:(_vm.position),callback:function ($$v) {_vm.position=$$v},expression:"position"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }